import { render } from "./LoadingWrap.vue?vue&type=template&id=01f73246&scoped=true"
const script = {}

import "./LoadingWrap.vue?vue&type=style&index=0&id=01f73246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f73246"]])

export default __exports__